import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styled, { ThemeProvider } from 'styled-components'
import Img from 'gatsby-image'

import { Grid, Column } from '../components/grid'
import { Segment } from '../components/segment'
import { HarvestTheme } from '../components/theme'
import { Header, AbsoluteHeader, Accent } from '../components/header'
import { Icon, Icons } from '../components/icon'
import { Footer } from '../components/footer'
import { Wrapper } from '../components/wrapper'
import { Hero } from '../components/hero'
import { Button } from '../components/button'
import { Navbar } from '../components/navbar'

// svg files
import harvestCrowdfund from '../assets/svg/Harvest_Crowdfund.svg'
import harvestExchange from '../assets/svg/Harvest_Exchange.svg'
import harvestInteractFans from '../assets/svg/Harvest_InteractFans.svg'
import harvestNetwork from '../assets/svg/Harvest_Network.svg'
import harvestRewardArtist from '../assets/svg/Harvest_RewardArtists.svg'

const TreblekeyPage = props => (
    <ThemeProvider theme={HarvestTheme}>
        <Wrapper>
            <Segment style={{ height: 0, padding: 0, margin: 0, zIndex: 999 }}>
                <Navbar>
                    <h3><a href='#top'>Harvest</a></h3>
                    <a href='#rewards'>Rewards</a>
                    <a href='#users'>Users</a>
                    <a href='#system'>System</a>
                </Navbar>
            </Segment>
            <div id='top' style={{ height: '3em' }} />
            <Helmet title='Harvest' />
            <Hero centered style={{ backgroundColor: '#FADE21', height: '30em' }}>
                <Header id='h1' style={{
                    overflow: 'hidden',
                    position: 'absolute',
                    top: '55%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    margin: 'auto',
                }}>
                    <h1 style={{ position: 'relative', lineHeight: '1.5em', fontSize: '5rem' }}>
                        Reward
                    <br />
                        Creation
                </h1>
                </Header>
                <Header inverse style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    margin: 'auto',
                }}>
                    <h3 style={{ position: 'relative' }}>
                        EMPOWERING ARTISTS IN THE DIGITAL AGE
                </h3>
                </Header>
            </Hero>
            <Segment dark >
                <div id='vision' style={{ position: 'relative', top: '-100px' }} />
                <Img
                    style={{ position: 'absolute', opacity: '0.3' }}
                    title='Accent image'
                    alt='guitars'
                    className='background'
                    sizes={props.data.pic01.sizes}
                />
                <div className='inner' style={{ zIndex: 1 }}>
                    <Grid>
                        <AbsoluteHeader accent>
                            <Grid>
                                <Column span='12'>
                                    <h1 style={{ overflow: 'hidden', position: 'relative', lineHeight: '1.5em', fontSize: '8em' }}>
                                        Vision
                                </h1>
                                </Column>
                            </Grid>
                        </AbsoluteHeader>
                        <Column style={{ position: 'relative', height: '8rem' }} span='12' />
                        <Column span='4' />
                        <Column span='7'>
                            <Header inverse>
                                <h4>OUR VISION
                                <div style={{ fontSize: '2em', transform: 'scaleY(0.5)' }}>-</div>
                                </h4>
                            </Header>
                            We want artists to all be rewarded equally,
                            based only on how much their fans love their music, not on whether its an ad-based stream, or what their deal split is with distributors & labels.
                        <br />
                            <br />
                            Pure, direct, whole rewards, from your fans!
                        </Column>
                        <Column style={{ position: 'relative', height: '6em' }} span='12' />
                    </Grid>
                </div>
            </Segment>
            <Segment centered>
                <div id='rewards' style={{ position: 'relative', top: '-100px' }} />
                <div className='inner'>
                    <Grid>
                        <Column span='12'>
                            <Header>
                                <h1 style={{ fontSize: '6rem' }}>Rewards</h1>
                            </Header>
                        </Column>

                        <Column span='1'>
                        </Column>
                        <Column span='10'>
                            <h4 style={{ color: 'black' }}>MOST REWARDS PROGRAMS ARE TIGHTLY CONTROLLED...</h4>
                            <p style={{ color: 'black' }}>Someone tells you when you can use your rewards, how you can use them, and charge <br />
                                you when you want to want to give them away.</p>
                        </Column>
                        <Column span='1'>
                        </Column>

                        <Column span='1'>
                        </Column>
                        <Column span='10'>
                            <h4 style={{ color: 'black' }}>HARVEST WANTS TO CHANGE ALL OF THAT</h4>
                        </Column>
                        <Column span='1'>
                        </Column>

                        <Column span='2'>
                        </Column>
                        <Column span='4'>
                            <img src={harvestRewardArtist} style={{ display: 'block', width: '7.5rem', margin: 'auto', padding: '2px' }} />
                            <p style={{ color: 'black' }}><b>Reward artists based on <br /> how much their fans <br />listened, not how!</b></p>
                        </Column>
                        <Column span='4'>
                            <img src={harvestCrowdfund} style={{ display: 'block', width: '6.25rem', margin: 'auto', padding: '5px' }} />
                            <p style={{ color: 'black' }}><b>Trade, donate or crowd- <br />fund with your points  <br /> freely!</b></p>
                        </Column>
                        <Column span='2'>
                        </Column>

                        <Column span='4'>
                            <img src={harvestNetwork} style={{ display: 'block', width: '6.25rem', margin: 'auto', padding: '2px' }} />
                            <p style={{ color: 'black' }}><b>Connect through a great <br /> network of apps!</b></p>
                        </Column>
                        <Column span='4'>
                            <img src={harvestInteractFans} style={{ display: 'block', width: '6.25rem', margin: 'auto', padding: '2px' }} />
                            <p style={{ color: 'black' }}><b>Interact and reward your <br /> biggest fans!</b></p>
                        </Column>
                        <Column span='4'>
                            <img src={harvestExchange} style={{ display: 'block', width: '7.5rem', margin: 'auto', padding: '2px' }} />
                            <p style={{ color: 'black', padding: '5px 0px 0px 0px' }}><b>Exchange your points for <br /> real services!*</b></p>
                        </Column>


                        <Column span='2'>
                        </Column>
                        <Column span='8'>
                            <br />
                            <p style={{ color: 'black' }}>*studio time, marketing, PPC advertising campaigns and more! </p>
                            <br />
                        </Column>
                        <Column span='2'>
                        </Column>
                    </Grid>
                </div>
            </Segment>
            <Segment dark >
                <div id='users' style={{ position: 'relative', top: '-100px' }} />
                <div className='inner'>
                    <Grid>
                        <AbsoluteHeader accent>
                            <Grid>
                                <Column span='12'>
                                    <h1 style={{ overflow: 'hidden', position: 'relative', lineHeight: '1.5em', fontSize: '8em' }}>
                                        Users
                                </h1>
                                </Column>
                            </Grid>
                        </AbsoluteHeader>
                        <Column style={{ position: 'relative', height: '10rem' }} span='12' />
                        <Column span='4' style={{ textAlign: 'center' }}>
                            <Header inverse>
                                <h5>ARTISTS
                            <div style={{ fontSize: '2em', transform: 'scaleY(0.5)' }}>-</div>
                                </h5>
                            </Header>
                            <p>
                                can use their points any way they want. Hold them, use
                                them to reward fans, collect them from fans to fund the
                                next recording, or toss them away. It was your music,
                                so it's your reward!
                        </p>
                        </Column>
                        <Column span='4' style={{ textAlign: 'center' }}>
                            <Header inverse>
                                <h5>FANS
                                <div style={{ fontSize: '2em', transform: 'scaleY(0.5)' }}>-</div>
                                </h5>
                            </Header>
                            <p>
                                can support their favourite artist by donating points safely
                                commiting to a crowdfunding campaign or simply just buying
                                them
                        </p>
                        </Column>
                        <Column span='4' style={{ textAlign: 'center' }}>
                            <Header inverse>
                                <h5>VENDORS &amp; LABELS
                                <div style={{ fontSize: '2em', transform: 'scaleY(0.5)' }}>-</div>
                                </h5>
                            </Header>
                            <p>
                                and others can accept points for services, buy and sell them
                            on a exchange trade them for services themselves. Make a <br />
                                difference by supporting a free, open, transparent rewards
                                program for artists!
                        </p>
                        </Column>
                        <Column style={{ position: 'relative', height: '6em' }} span='12' />
                    </Grid>
                </div>
            </Segment>
            <Segment centered>
                <div id='system' style={{ position: 'relative', top: '-100px' }} />
                <div className='inner'>
                    <Grid>
                        <Column span='12'>
                            <Header>
                                <h1 style={{ fontSize: '5rem' }}>GET INVOLVED</h1>
                            </Header>
                        </Column>
                        <Column span='2'>
                        </Column>
                        <Column span='8'>
                            <Header inverse>
                                <a href='mailto:canada@membran.net' style={{ borderBottom: 'none' }}><Button hover='white' unstyled='true' font='body' inverse>
                                    <h3>
                                        CONTACT US!
                                </h3>

                                </Button>
                                </a>

                                <h5>
                                    <div style={{ fontSize: '2em', transform: 'scaleY(0.5)' }}>-</div>
                                </h5>
                            </Header>
                            <p style={{ color: 'black' }}><b>Express your interest learn more, and help us build a new <br />
                                music ecosystem based on equality. </b></p>
                        </Column>
                    </Grid>
                </div>
            </Segment>
            <Footer dark>
                <div />
                <div>
                    <Header>
                        <h3 style={{ color: 'black', fontSize: '20', textAlign: 'center', fontWeight: '700' }}>EXPLORE</h3>
                    </Header>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }}>

                        <h1>-</h1>
                        <li style={{ fontSize: '16' }}><a href='http://www.membran.net'>MEMBRAN.NET</a></li>
                        <li style={{ fontSize: '16' }}><a href='/' >MEMBRANLABS.COM</a></li>
                        <li style={{ fontSize: '16' }}><a href='/treblekey'>TREBLEKEY</a></li>
                        <li style={{ fontSize: '16' }}><Accent>HARVEST</Accent></li>
                        <li style={{ fontSize: '16' }}><a href='/hyperstate' >HYPERSTATE</a></li>
                    </ul>
                </div>
                <div>
                    <Header>
                        <h3 style={{ color: 'black', fontSize: '20', textAlign: 'center', fontWeight: '700' }}>CONTACT US</h3>
                    </Header>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }}>
                        <h1>-</h1>
                        <li style={{ fontSize: '16' }}><a href='mailto:canada@membran.net' >EMAIL</a></li>
                    </ul>
                </div>
            </Footer>
        </Wrapper>
    </ThemeProvider>
)

export default TreblekeyPage

export const pageQuery = graphql`
  query HarvestHeaderImageQuery {
    pic01: imageSharp(id: { regex: "/harvest_01/" }) {
        sizes(maxWidth: 2000 ) {
            ...GatsbyImageSharpSizes
        }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/harvest.js